/*
 * CRS BBS · 人机验证（照发色选图）
 *
 * 三个时机：
 *   1) 注册弹窗（SignUpModal）—— 点「注册」前必须通过；
 *   2) 找回密码弹窗（ForgotPasswordModal）—— 点「找回密码」前必须通过；
 *   3) 新人（commentCount === 0）发第一帖 —— 点「发布」时弹出九宫格。
 *
 * 通过后服务端下发一次性通行 Cookie（bbs_bot_pass），随后的请求自动带上；
 * 服务端（BotGuardMiddleware）会再校验一次，前端拦截只是为了让体验顺一点。
 * 兼容老 WebView：ES5 风格、不用可选链/??/展开 NodeList。
 */

import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Component from 'flarum/common/Component';
import { extend, override } from 'flarum/common/extend';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import ForgotPasswordModal from 'flarum/forum/components/ForgotPasswordModal';
import ChangePasswordModal from 'flarum/forum/components/ChangePasswordModal';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';

const TITLE = '我们怀疑你不是人类 请证明awa';
const API = function () {
  return app.forum.attribute('apiUrl') + '/bot-guard';
};

/* ------------------------------------------------------------------ *
 * 九宫格组件
 * ------------------------------------------------------------------ */

class BbsCaptcha extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.images = [];
    this.token = '';
    this.prompt = '';
    this.title = TITLE;
    this.picked = {};
    this.msg = '';
    this.ok = false;
    this.loading = true;
    this.working = false;
    this.shake = false;
    if (vnode.attrs && typeof vnode.attrs.register === 'function') {
      vnode.attrs.register(this);
    }
    this.load();
  }

  load(keepMsg) {
    const self = this;
    this.loading = true;
    this.working = false;
    this.ok = false;
    this.picked = {};
    this.images = [];
    if (!keepMsg) this.msg = '';
    app
      .request({ method: 'POST', url: API() + '/challenge', body: {} })
      .then(function (res) {
        self.token = (res && res.token) || '';
        self.images = (res && res.images) || [];
        self.prompt = (res && res.prompt) || '';
        self.title = (res && res.title) || TITLE;
        self.loading = false;
        m.redraw();
      })
      .catch(function () {
        self.loading = false;
        self.token = '';
        self.msg = '验证码加载失败，点「换一批」再试试喵~';
        m.redraw();
      });
  }

  toggle(i) {
    if (this.ok || this.working) return;
    this.picked[i] = !this.picked[i];
  }

  selectedIndexes() {
    const out = [];
    for (let i = 0; i < this.images.length; i++) {
      if (this.picked[i]) out.push(i);
    }
    return out;
  }

  doShake() {
    const self = this;
    this.shake = true;
    setTimeout(function () {
      self.shake = false;
      m.redraw();
    }, 450);
  }

  submit() {
    if (this.ok || this.working || !this.token) return;
    const sel = this.selectedIndexes();
    if (sel.length === 0) {
      this.msg = '还没选呢，点一下图片再按「确认」嘛awa';
      this.doShake();
      return;
    }

    const self = this;
    this.working = true;
    this.msg = '验证中…';
    app
      .request({
        method: 'POST',
        url: API() + '/verify',
        body: { token: this.token, selected: sel },
      })
      .then(function (res) {
        self.working = false;
        if (res && res.ok) {
          self.ok = true;
          self.msg = res.message || '你好，人';
          if (self.attrs && typeof self.attrs.onpass === 'function') {
            try {
              self.attrs.onpass();
            } catch (e) {}
          }
        } else {
          self.msg = (res && res.message) || '人机别来凑热闹awa';
          self.doShake();
          if (!res || res.retry) {
            setTimeout(function () {
              if (!self.ok) self.load(true);
            }, 1400);
          }
        }
        m.redraw();
      })
      .catch(function () {
        self.working = false;
        self.msg = '网络不太顺，再试一次喵~';
        m.redraw();
      });
  }

  view() {
    if (this.loading) {
      return m(
        'div.bbs-captcha',
        { 'data-token': '' },
        m('div.bbs-captcha-title', this.title),
        m('div.bbs-captcha-loading', '正在出题…')
      );
    }

    const cells = [];
    for (let i = 0; i < this.images.length; i++) {
      let cls = 'div.bbs-captcha-cell';
      if (this.picked[i]) cls += '.selected';
      if (this.ok) cls += '.locked';
      cells.push(
        m(
          cls,
          {
            'data-index': i,
            onclick: this.toggle.bind(this, i),
          },
          m('img', { src: this.images[i], alt: '', draggable: 'false' })
        )
      );
    }

    let msg = this.msg;
    let hint = false;
    if (!this.ok && !msg && this.attrs && typeof this.attrs.hint === 'function') {
      try {
        hint = !!this.attrs.hint();
      } catch (e) {
        hint = false;
      }
    }
    if (!this.ok && !msg && hint) {
      msg = '还没通过验证呢：先选出全部目标图片，按「确认」再提交嘛awa';
    }

    let msgCls = 'bbs-captcha-msg';
    if (this.ok) msgCls += ' ok';
    else if (msg) msgCls += ' bad';

    let rootCls = 'div.bbs-captcha';
    if (this.shake) rootCls += '.shake';

    return m(
      rootCls,
      { 'data-token': this.token },
      m('div.bbs-captcha-title', this.title),
      m('div.bbs-captcha-prompt', this.prompt),
      m('div.bbs-captcha-grid', cells),
      m('div', { className: msgCls }, msg),
      m(
        'div.bbs-captcha-actions',
        m(
          Button,
          {
            className: 'Button',
            disabled: this.working,
            onclick: this.load.bind(this, false),
          },
          '换一批'
        ),
        m(
          Button,
          {
            className: 'Button Button--primary',
            loading: this.working,
            disabled: this.ok,
            onclick: this.submit.bind(this),
          },
          this.ok ? '已通过' : '确认'
        )
      )
    );
  }
}

/* ------------------------------------------------------------------ *
 * 弹出式（发帖时用）
 * ------------------------------------------------------------------ */

class BbsCaptchaModal extends Modal {
  className() {
    return 'Modal--small BbsCaptchaModal';
  }

  title() {
    return TITLE;
  }

  content() {
    return m(
      'div.Modal-body',
      m(BbsCaptcha, {
        register: this.attrs.register,
        onpass: this.attrs.onpass,
      })
    );
  }
}

/* ------------------------------------------------------------------ *
 * 挂钩
 * ------------------------------------------------------------------ */

// 注册 / 找回密码 / 更改密码：把验证码内联进表单，点提交时要求已通过
// priority：ItemList 里验证码的排序（数值越大越靠前），默认 -5（排在提交按钮前面）
function hookFormModal(Cls, priority) {
  extend(Cls.prototype, 'fields', function (items) {
    const self = this;
    items.add(
      'bbsCaptcha',
      m(
        'div.Form-group',
        m(BbsCaptcha, {
          register: function (inst) {
            self.bbsCaptchaApi = inst;
          },
          hint: function () {
            return !!self.bbsCaptchaNeed;
          },
          onpass: function () {
            self.bbsCaptchaNeed = false;
            self.bbsCaptchaOk = true;
          },
        })
      ),
      typeof priority === 'number' ? priority : -5
    );

    return items;
  });

  override(Cls.prototype, 'onsubmit', function (original) {
    const args = Array.prototype.slice.call(arguments, 1);
    if (this.bbsCaptchaOk) {
      return original.apply(this, args);
    }
    if (args[0] && typeof args[0].preventDefault === 'function') {
      args[0].preventDefault();
    }
    this.bbsCaptchaNeed = true;
    m.redraw();
    const el = document.querySelector('.Modal .bbs-captcha');
    if (el && el.scrollIntoView) {
      setTimeout(function () {
        el.scrollIntoView({ block: 'center' });
      }, 30);
    }
  });

  // 提交失败（多半是验证令牌已被消费或字段有误）：让用户重新过一次验证
  override(Cls.prototype, 'onerror', function (original) {
    const args = Array.prototype.slice.call(arguments, 1);
    const err = args[0];
    if (err && Number(err.status) === 422 && this.bbsCaptchaOk) {
      this.bbsCaptchaOk = false;
      this.bbsCaptchaNeed = true;
      if (this.bbsCaptchaApi && typeof this.bbsCaptchaApi.load === 'function') {
        this.bbsCaptchaApi.load(false);
      }
    }
    return original.apply(this, args);
  });
}

// 新人第一帖：点提交时弹九宫格，通过后自动继续提交
function needCaptchaForPost() {
  const u = app.session.user;
  if (!u) return false;
  try {
    if (typeof u.isAdmin === 'function' && u.isAdmin()) return false;
  } catch (e) {}
  const c = u.attribute('commentCount');
  if (c === undefined || c === null) return false; // 拿不到就交给服务端兜底

  return Number(c) === 0;
}

function hookComposer(Cls) {
  override(Cls.prototype, 'onsubmit', function (original) {
    const args = Array.prototype.slice.call(arguments, 1);
    const self = this;

    if (self.bbsCaptchaOk) {
      self.bbsCaptchaOk = false;
      return original.apply(this, args);
    }
    if (!needCaptchaForPost()) {
      return original.apply(this, args);
    }

    try {
      app.modal.show(BbsCaptchaModal, {
        register: function () {},
        onpass: function () {
          self.bbsCaptchaOk = true;
          setTimeout(function () {
            app.modal.close();
            original.apply(self, args);
            self.bbsCaptchaOk = false;
          }, 600);
        },
      });
    } catch (e) {
      // 弹窗失败就直接放行，交给服务端中间件兜底
      return original.apply(this, args);
    }
  });
}

/* ------------------------------------------------------------------ *
 * 注册初始化器
 * ------------------------------------------------------------------ */

app.initializers.add('bbs-bot-guard', function () {
  try {
    hookFormModal(SignUpModal);
    hookFormModal(ForgotPasswordModal);
    // 设置页的「更改密码」其实是发重置邮件（POST /api/forgot），同样要过验证码；
    // 它 fields() 里的 help/submit 优先级是 0，所以这里用 1 让九宫格排在最上面。
    hookFormModal(ChangePasswordModal, 1);
    hookComposer(ReplyComposer);
    hookComposer(DiscussionComposer);
  } catch (e) {
    // 永远不要因为验证码把站点前端弄崩
  }
});

export default BbsCaptcha;
